import { render } from "./BillingAndPayments.vue?vue&type=template&id=e5215f54&scoped=true"
import script from "./BillingAndPayments.vue?vue&type=script&lang=js"
export * from "./BillingAndPayments.vue?vue&type=script&lang=js"

import "./BillingAndPayments.vue?vue&type=style&index=0&id=e5215f54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e5215f54"

export default script